import styled from 'styled-components/macro';

export const Error = styled.div`
  grid-column: 1 / -1;
`;
